import React, { useEffect } from "react";
import { PageHeader } from "../../components/Header";
import { PageWrapper } from "../../components/Page";
import { Button } from "../../components/Button";
import { ArrowBack, ArrowForward, OpenInNew } from "@material-ui/icons";
import { ProjectExpander } from "../Project";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getCart,
    getCartId,
    getCurrentProject, getLoading,
} from "../../reducers/project/selectors";
import { IProject } from "../../reducers/project";
import Scrollbars from "react-custom-scrollbars";
import { useFetch } from "../../hooks/useFetch";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { isEqual } from "lodash/fp";
import useThrottledEffect from "use-throttled-effect";
import content from "../../content";
import { DrawerMenu } from "../../components/Menu";
import { PriceExpander } from "../PriceExpander";
import { Mobile, useDesktop } from "../../components/Responsive";

const Label = styled.div`
  height: 55px;
  border-top: 1px solid #aaaaaa;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  font-weight: bold;
  font-size: 18px;
`;

const Label2 = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #080808;
  opacity: 0.8;
`;

function ProjectsCart({}: IProjectsCart) {
  const cart: IProject[] = useSelector(getCart);
  const cartId = useSelector(getCartId);

  const desktop = useDesktop();

    const loading = useSelector(getLoading)

  const [responseNew, requestNew] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/");

  const [responseUpdate, requestUpdate] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/", {} as any, {
    method: "PUT",
  });

  const dispatch = useDispatch();

  const reset = () => dispatch({ type: ProjectActions.Reset });


  useThrottledEffect(
    () => {
      if (
        cartId &&
        cart &&
        !isEqual(cart, responseUpdate?.projects as any)
      ) {
        requestUpdate(
          {
            projects: cart,
          },
          cartId
        ).then((project) => {
          dispatch({
            type: ProjectActions.UpdateCart,
            cart: project,
          });
        });
      } else {
        if (cart && !isEqual(cart, responseNew?.projects as any) && !cartId) {
          requestNew({
            projects: cart,
          }).then((project) => {
            dispatch({
              type: ProjectActions.UpdateCart,
              cart: project,
            });
          });
        }
      }
    },
    1000,
    [cart, cartId, responseNew, responseUpdate]
  );

  return (
    <>
      <PageHeader header={content.getValue("header_cart")} />
      <PageWrapper
        padding={desktop ? "32px 40px" : "16px 16px"}
        menu={
          <>
            <DrawerMenu
              Icon={
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="21" cy="21" r="21" fill="#080808" />
                  <path
                    d="M30.8388 23.3588L32.9726 14.8275C33.1267 14.2116 32.6114 13.625 31.9162 13.625H14.1865L13.7727 11.7871C13.6696 11.329 13.226 11 12.7114 11H8.08333C7.48502 11 7 11.4407 7 11.9844V12.6406C7 13.1843 7.48502 13.625 8.08333 13.625H11.2378L14.4087 27.7112C13.6501 28.1076 13.1389 28.8509 13.1389 29.7031C13.1389 30.9717 14.2706 32 15.6667 32C17.0627 32 18.1944 30.9717 18.1944 29.7031C18.1944 29.0602 17.9034 28.4794 17.435 28.0625H26.8983C26.4299 28.4794 26.1389 29.0602 26.1389 29.7031C26.1389 30.9717 27.2706 32 28.6667 32C30.0627 32 31.1945 30.9717 31.1945 29.7031C31.1945 28.7937 30.6127 28.0079 29.769 27.6357L30.018 26.64C30.1721 26.0241 29.6568 25.4375 28.9617 25.4375H16.8456L16.5501 24.125H29.7824C30.2882 24.125 30.7267 23.807 30.8388 23.3588Z"
                    fill="white"
                  />
                </svg>
              }
              title={content.getValue("drawer_project_cart_title")}
              text={content.getValue("drawer_project_cart_text")}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginRight: "8px",
                padding: "24px",
                boxSizing: "border-box",
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              <Label2>{content.getValue("price")}</Label2>
              <Label2 style={{ color: "#C41230", opacity: 1 }}>
                {cart.length === 0
                  ? 0
                  : cart
                    .reduce(
                      (a, b: any) =>
                        a.concat(
                          b.components.map((c: any) => ({
                            ...c,
                            price: Number(c.price) * b.count,
                          }))
                        ),
                      []
                    )
                    .reduce(
                      (a, b: any) => (Number(a) + Number(b.price)).toFixed(2),
                      ""
                    )}{" "}
                {content.getValue("price_surfix")}
              </Label2>
            </div>
            <div style={{display: 'flex', width: '100%', paddingLeft: '24px', boxSizing: "border-box"}}>
              <div style={{
                boxSizing: "border-box",
                padding: "0px 24px 24px 0px",
                width: '50%'
              }}>
                <Link to={'/'}>
                  <Button
                    startIcon={
                      <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z" fill="#838282"/>
                      </svg>

                    }
                    variant={"text"}
                    label={content.getValue("button_back_to_creator")} /></Link>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  padding: "0px 24px 24px 0px",
                  width: '50%',
                  pointerEvents: cart.length === 0?'none':'all'
                }}
              >
                <Link style={{pointerEvents: cart.length === 0? 'none':'unset'}} to={"/order"}>
                  <Button
                    color={"secondary"}
                    variant={"outlined"}
                    loading={loading}
                    disabled={loading || cart.length === 0}
                    Icon={
                      <svg
                        style={{
                          position: "absolute",
                          right: "20px",
                        }}
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                          fill={
                            cart.length === 0 ? "rgba(0, 0, 0, 0.26)" : "#C41230"
                          }
                        />
                      </svg>
                    }
                    label={content.getValue("button_order")}
                  />
                </Link>
              </div>
            </div>
          </>
        }
      >
        <div
          style={{
            display: "flex",
            height: `calc(100vh - ${desktop ? 267 : 195}px)`,
            maxHeight: `calc(100vh - ${desktop ? 267 : 195}px)`,
          }}
        >
          <Scrollbars
            autoHeight={true}
            autoHeightMin={"100%"}
            autoHeightMax={"100%"}
          >
            {cart.map((c) => (
              <ProjectExpander key={c.id} project={c} />
            ))}
            <Link to={"/"} onClick={reset}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "70px",
                  marginBottom: "25px",
                  border: "2px dashed #C41230",
                  boxSizing: "border-box",
                  cursor: "pointer",
                }}
              >
                <svg
                  style={{ marginRight: "5px" }}
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle opacity="0.1" cx="13" cy="13" r="13" fill="#C41230" />
                  <line
                    x1="7"
                    y1="12.7858"
                    x2="18"
                    y2="12.7858"
                    stroke="#C41230"
                    stroke-width="2"
                  />
                  <line
                    x1="12.7145"
                    y1="7.5"
                    x2="12.7145"
                    y2="18.5"
                    stroke="#C41230"
                    stroke-width="2"
                  />
                </svg>

                {content.getValue("button_new_project")}
              </div>
            </Link>
          </Scrollbars>
        </div>
        <Mobile>
          <Link style={{pointerEvents: cart.length === 0? 'none':'unset'}} to={"/order"}>
            <Button
              Icon={
                <svg
                  style={{
                    position: "absolute",
                    right: "20px",
                  }}
                  width="17"
                  height="8"
                  viewBox="0 0 17 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                    fill={cart.length === 0 ? "rgba(0, 0, 0, 0.26)" : "#C41230"}
                  />
                </svg>
              }
              color={"secondary"}
              variant={"outlined"}
              disabled={cart.length === 0}
              label={content.getValue("button_order")}
            />
          </Link>
        </Mobile>
      </PageWrapper>
    </>
  );
}

export interface IProjectsCart {}

export default ProjectsCart;
